import { format, parseISO } from 'date-fns';
import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FaFolderOpen, FaStickyNote } from 'react-icons/fa';

function formatDateTime(dt: any) {
  return format(parseISO(dt), 'dd/MM/yyyy HH:mm');
}
export const LegacyTooltip = ({ data }) => {
  const { t } = useTranslation();
  const recordDate = data?.recordDate !== null && data?.recordDate !== undefined ? formatDateTime(data.recordDate) : '';
  return (
    <OverlayTrigger
      trigger={['hover', 'focus']}
      delay={{ show: 300, hide: 3000 }}
      overlay={
        <Tooltip id={`overlay-${data.firstUser}`}>
          <div style={{ margin: '5px' }}>
            <h6 className="text-center">{t('Legacy')}</h6>
            <h6 className="text-start">
              {t('ID')}: {data.legacyAppId}
            </h6>
            <h6 className="text-start">
              {t('Ημ/νία Καταγραφής')}: {recordDate}
            </h6>
          </div>
        </Tooltip>
      }
      placement="left"
    >
      <span style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}>
        <FaFolderOpen size="1.5rem" className="pe-1" />
      </span>
    </OverlayTrigger>
  );
};

